<template>
  <v-select
    :items="yearOptions"
    v-bind="$attrs"
    :value="value"
    :label="trans('general.year')"
    @input="$emit('input', $event)"
  ></v-select>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'SelectYear',
  mixins: [
    LocaleUtils
  ],
  props: {
    minYear: {
      default  () {
        return (new Date().getFullYear()) - 10;
      }
    },
    maxYear: {
      default () {
        return (new Date().getFullYear()) + 3;
      }
    },
    value: {
      default () {
        return new Date().getFullYear();
      }
    }
  },
  computed: {
    yearOptions () {
      let years = [];

      for (let year = this.maxYear; year >= this.minYear; year--) {
        years.push(year);
      }

      return years;
    }
  }
}
</script>
